// extracted by mini-css-extract-plugin
export default {"root":"WebApp_root__TTg4+","appContainer":"WebApp_appContainer__3wrKo","content":"WebApp_content__l2xW+"};